import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics, { initAnalytics, trackPageView } from '../utils/analytics';

// Create analytics context
const AnalyticsContext = createContext();

/**
 * Analytics Provider component that initializes analytics and tracks page views
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {React.ReactElement} - React component
 */
export const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  // Initialize analytics on mount
  useEffect(() => {
    initAnalytics();
  }, []);

  // Track page views when location changes
  useEffect(() => {
    const path = location.pathname + location.search;
    const title = document.title;
    trackPageView(path, title);
  }, [location]);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

/**
 * Hook to use analytics in components
 * @returns {Object} - Analytics methods
 */
export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export default AnalyticsContext;
